import { Getter, GetterTree } from 'vuex'

import { ISocketState } from '@/system/socket/store'

import { GET_IS_CONNECTED, GET_RECONNECT_ERROR } from '@/system/store/getter-types'

const getIsConnected: Getter<ISocketState, any> = (state: ISocketState) => {
  const { isConnected } = state
  return isConnected
}

const getReconnectError: Getter<ISocketState, any> = (state: ISocketState) => {
  const { reconnectError } = state
  return reconnectError
}

const getters: GetterTree<ISocketState, any> = {
  [GET_IS_CONNECTED]: getIsConnected,
  [GET_RECONNECT_ERROR]: getReconnectError
}

export default getters
